module.exports = __webpack_public_path__ + "static/media/CVS-CATCH-MS-SPM-LandingPage-vape-lineup.74f1f429.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CVS-CATCH-MS-SPM-LandingPage-vape-lineup.svg
// module id = 519
// module chunks = 0